import { client } from '@/client';
import { resolveData } from '@/util/api-helpers';

export async function fetchZips() {
   return client.get('/api/zips')
      .then(resolveData);
}

export async function addToBlacklist(slug, code) {
   return client.post(`api/zips/${slug}/blacklist/${code}`)
      .then(resolveData);
}

export async function removeFromBlacklist(slug, code) {
   return client.delete(`api/zips/${slug}/blacklist/${code}`)
      .then(resolveData);
}

export async function setBlacklist(slug, blacklist) {
   return client.post(`api/zips/${slug}/blacklist/set`, { blacklist })
      .then(resolveData);
}

export async function setWhitelist(slug, whitelist) {
   return client.post(`api/zips/${slug}/whitelist/set`, { whitelist })
      .then(resolveData);
}
